/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Return_Decision_TitleInputs */

const vi_carrier_return_decision_title = /** @type {(inputs: Carrier_Return_Decision_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phản hồi yêu cầu chuyển hoàn`)
};

/**

* @param {Carrier_Return_Decision_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_return_decision_title = /** @type {((inputs?: Carrier_Return_Decision_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Return_Decision_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_return_decision_title(inputs)
});